import userActions from 'features/user/services/actions';
import { EMainLayout } from 'features/user/services/constants';
import userSelectors from 'features/user/services/selectors';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import IconGeneral from './generalIcon';
import IconList from './listIcon';

const LayoutButton = () => {
  const homeLayout = userSelectors.homeLayout();
  const dispatch = useAppDispatch();
  const changeLayout = (layout: EMainLayout) => () => dispatch(userActions.changeHomeLayout(layout));

  return (
    <LayoutButtonStyled>
      <button onClick={changeLayout(EMainLayout.FULL_STAFFS)}><IconList active={homeLayout === EMainLayout.FULL_STAFFS} /></button>
      <button onClick={changeLayout(EMainLayout.GENERAL)}><IconGeneral active={homeLayout === EMainLayout.GENERAL} /></button>
    </LayoutButtonStyled>
  );
};

export default LayoutButton;
const LayoutButtonStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  gap: 8px;
`;
